import React, { useLayoutEffect, useRef, useState } from "react"
import styles from "./Clara.module.css"

// Eight lines of answer text at the chat's 15.5px / 1.62 line height.
const COLLAPSED_PX = Math.round(8 * 15.5 * 1.62)

/* An answer longer than about eight lines opens collapsed, with "Show more".

   The introduction ran to about 25 lines and a policy answer could be longer, pushing the
   chart and the sources of the same answer off screen (UI review, 1 Oct). Only a FINISHED
   answer is measured and folded: folding while it is still streaming in would hide the
   words as they arrive. */
export function LongAnswer({ done, children }) {
	const bodyRef = useRef(null)
	const [tall, setTall] = useState(false)
	const [expanded, setExpanded] = useState(false)

	useLayoutEffect(() => {
		if (!done || !bodyRef.current) {
			return
		}
		setTall(bodyRef.current.scrollHeight > COLLAPSED_PX + 24)
	}, [done, children])

	const collapsed = tall && !expanded
	return (
		<>
			<div
				ref={bodyRef}
				className={collapsed ? styles.answerCollapsed : undefined}
				style={collapsed ? { maxHeight: COLLAPSED_PX } : undefined}
			>
				{children}
			</div>
			{tall && (
				<button type="button" className={styles.showMore} onClick={() => setExpanded(value => !value)} aria-expanded={expanded}>
					{expanded ? "Show less" : "Show more"}
				</button>
			)}
		</>
	)
}
